
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-59e2cff7&scoped=true!../node_modules/vue-loader/lib/selector?type=styles&index=0!./SettingsHubPage.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./SettingsHubPage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-59e2cff7!../node_modules/vue-loader/lib/selector?type=template&index=0!./SettingsHubPage.vue"),
  /* scopeId */
  "data-v-59e2cff7",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/SettingsHubPage.vue
// module id = 294
// module chunks = 2